import React from "react";
import Message from "components/message";

function FetchAgain(props) {
  return <Message warning message="noEntriesToDisplayAutoFetch" />;
}

export default FetchAgain;
